module.exports = __webpack_public_path__ + "img/exe.23d9bbd0.svg";